const clearFilters = () => {
    const currentURL = new URL(window.location.href);
    currentURL.search = "";
    window.location.href = currentURL.toString();
};

// const applyFilters = () => {
//     console.log("apply");
// }

const handleFilersButtons = () => {
    const resetButton = document.getElementById("resetFilters");
    const applyButton = document.getElementById("applyFilters");
    applyButton &&
        applyButton.addEventListener("click", () => {
            document.body.classList.remove("filters-active");
        });
    resetButton?.addEventListener("click", clearFilters);
    // if (applyButton && mobile.matches) {
    //     applyButton.addEventListener("click", applyFilters);
    // }
};

export default handleFilersButtons;
